import { default as MuiDivider } from '@mui/material/Divider';

/**
 * Dividers are thin lines that bring clarity to a layout by grouping and dividing content.
 *
 * Demos:
 *
 * - [Divider](https://unify.workiva.org/components/divider?tab=code)
 *
 * API:
 *
 * - [Divider API](https://unify.workiva.org/components/divider?tab=props)
 */
export const Divider = MuiDivider;
export { type DividerProps, dividerClasses } from '@mui/material/Divider';
